
import * as actions from "appRedux/actions/setup/propertyInfo/PropertyActionType"

export type dataSourceType = {
    prop_id?:number,
    prop_code: string|null
    prop_name: string|null
    company: string|null
    tax_id?: string|null
    address1: string|null
    address2: string|null
    address3: string|null
    address4: string|null
    email: string|null
    telephone: string|null
    fax: string|null
    website: string|null
    logo: string|null
    logo_type: string|null
}

export type PropertyInfoState = {
    loader: boolean
    dataSource: dataSourceType
    process: any
}

export const initialPropertyDefaultData = {
    prop_id: undefined,
    prop_code: null,
    prop_name: null,
    company: null,
    tax_id: null,
    address1: null,
    address2: null,
    address3: null,
    address4: null,
    email: null,
    telephone: null,
    fax: null,
    website: null,
    logo: null,
    logo_type: null,
}

const initialState: PropertyInfoState = {
    loader: false,
    dataSource: {...initialPropertyDefaultData},
    process: { status: false, action: "", message: "" }
}


const propertyInfoReducer = (state: PropertyInfoState = initialState, action: actions.PropertyAction): PropertyInfoState => {
    switch (action.type) {
        case actions.PROPERTY_PREVIEW:
            return {
                ...state,
                loader: true,
                process:{status:false,action:"",message:""} 
            }

        case actions.PROPERTY_UPDATE: 
            return {
                ...state,
                loader: true,
                process:{status:false,action:"",message:""} 
            }

        case actions.PROPERTY_PROCESS_SUCCESS:
            return {
                ...state,
                loader: false,
                process:action.payload
            }
        case actions.PROPERTY_DATASOURCE_SUCCESS: {
            return {
                ...state,
                loader: false,
                dataSource: action.payload
            }
        }
        case actions.PROPERTY_PROCESS_RESET:
            return {
                ...state,
                loader: false,
                process:{status:false,action:"",message:""} 
            }
        default:
            return state
    }
}

export default propertyInfoReducer